<template>
    <div class="container lnb d_container">
        <div class="contents_wrap">
            <div class="contents list-container">
                <div class="title">
                    환불상세정보
                </div>
                <div class="refund_caption">결제상품에 대한 결제취소처리는 관리자가 스토어에서 직접 진행하기때문에 앱내 재화는 그대로 남아있습니다. <br>
                    결제취소 처리 이전에 사용자의 환불요청상품이 미사용상태로 보관중인지 확인하신 후 삭제처리 후 결제취소 처리를 진행하시기 바랍니다.
                </div>
                <refund-write-component :refundType="'detail'" :refundKey="refundKey"></refund-write-component>
                <div class="pa15 text-center btn_wrap">
                    <el-button type="save" @click="save">저장</el-button>
                    <el-button type="cancel" @click="backEvent()" :disabled="disableBtn">목록</el-button>
                </div>
            </div>
            <div class="footer-copyright">Copyright 2021. Peopleandtalk co.,Ltd. All rights reserved</div>
        </div>
    </div>
</template>

<script>
import EventBus from "@/utils/event-bus";
import RefundWriteComponent from "@/components/refund/RefundWriteComponent";

export default {
    name: "RefundDetail",
    mixins: [],
    components: {RefundWriteComponent},
    provide() {
        return {}
    },
    props: {},
    data() {
        return {
            refundKey: this.$route.params.idx,
            disableBtn: false,
        }
    },
    created() {
    },
    mounted() {
    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {
        save() {
            EventBus.$emit('writeRefund');
        },
        backEvent() {
            this.disableBtn = true
            this.$router.back()
        },
    },
    watch: {},
}
</script>

<style lang="scss">
</style>